// src/pages/Pedido/ResumoPedidoSemLogin.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import { FaRegCheckSquare } from "react-icons/fa";
import './ResumoPedido.css';
import MainContent from '../../components/Form/MainContent';
import { formatCurrency } from '../../utils/numberUtils';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import food from "../../images/food.ico";
import { useTheme } from '../../contexts/ThemeContext';
import { getPedidoNumero } from '../../utils/pedidoUtils';
import PixNoResumo from './PixNoResumo';
import ResumoItensPedido from './ResumoItensPedido';

const ResumoPedidoSemLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tokenResumo } = useParams();
  const { fetchData } = useApi();
  const { configModulo } = useTheme();
  const [pedido, setPedido] = useState(location.state?.pedido || null); // Recebe o objeto pedido via state
  const [erroResumo, setErroResumo] = useState('');
  const [recarregar, setRecarregar] = useState(0);

  useEffect(() => {
    if (!tokenResumo && !pedido) {
      // Se não houver pedido no state, redireciona para a página inicial
      navigate('/');
      return;
    }

    if (!tokenResumo) return;
    let ativo = true;
    fetchData(`/PedidoSemLoginDelivery/Resumo/${encodeURIComponent(tokenResumo)}`)
      .then(resumo => {
        if (ativo) {
          setPedido(resumo);
          setErroResumo('');
        }
      })
      .catch(() => {
        if (ativo) setErroResumo('Não foi possível carregar o resumo do pedido.');
      });
    return () => { ativo = false; };
  }, [tokenResumo, recarregar]);

  useEffect(() => {
    if (!location.state?.pedido) return;
    // Enviar notificação inicial
    toast.info(`Seu pedido #${getPedidoNumero(location.state.pedido, configModulo?.UsaIdDia)} foi confirmado! Acompanhe as atualizações pelo WhatsApp.`, {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      icon: food,
    });
  }, [location.state, configModulo]);

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(date).toLocaleDateString("pt-BR", options);
  };

  const handleOkClick = () => {
    navigate('/');
  };

  if (!pedido) {
    return erroResumo ? <div role="alert">{erroResumo} <button type="button" onClick={() => setRecarregar(valor => valor + 1)}>Tentar novamente</button></div> : <p>Carregando...</p>;
  }

  return (
    <>
      <Header titulo="Resumo do Pedido" routeGoBack="/" />
      <MainContent className="resumo-pedido-main">
        <div className="resumo-container">
          <div className="resumo-confirmacao">
            <FaRegCheckSquare className="resumo-confirmacao-icone" aria-hidden="true" />
            <div className="resumo-confirmacao-texto">
              <h3>Pedido #{getPedidoNumero(pedido, configModulo?.UsaIdDia)} confirmado</h3>
              <p>Realizado em: {formatDate(pedido.dataHoraPedido)}</p>
              <p>Acompanhe as atualizações pelo WhatsApp.</p>
            </div>
          </div>

          {erroResumo && <p role="alert">{erroResumo}</p>}
          <PixNoResumo pedido={pedido} onRetry={() => setRecarregar(valor => valor + 1)} />

          <section className="resumo-detalhes" aria-label="Detalhes do pedido">
            <ResumoItensPedido pedido={pedido} />

            {pedido.enderecoCliente && (
              <>
                <h4>Informações de Entrega</h4>
                <p>Endereço: {pedido.enderecoCliente}</p>
              </>
            )}

            <p>Cliente: {pedido.nomeCliente}</p>
            <p>Telefone: {pedido.telefoneCliente}</p>

            <h4>Forma de Pagamento</h4>
            <p>{pedido.formaPagamento}</p>

            <h4>Valores</h4>
            <p>Valor dos Itens: {formatCurrency(pedido.valorItens)}</p>
            {pedido.taxaEntrega > 0 && <p>Taxa de Entrega: {formatCurrency(pedido.taxaEntrega)}</p>}
            {pedido.valorDesconto > 0 && <p>Desconto: -{formatCurrency(pedido.valorDesconto)}</p>}
            <p><b>Total: {formatCurrency(pedido.valorTotal)}</b></p>
          </section>

          <button className="ok-button" onClick={handleOkClick}>OK</button>
        </div>
      </MainContent>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default ResumoPedidoSemLogin;
